//if (window.SH_THEMPLATE != 'shogun') {
let checkInterval = setInterval(async () => {
  if (window.inveterate !== undefined && window.inveterate.properties !== undefined && window.inveterate.properties.product !== undefined) {
    clearInterval(checkInterval); // Stop checking
    
    await inveterateInit();
  }
}, 300);

//}


function formatWithDelimiters(number, precision = 2, thousands = ',', decimal = '.') {
  if (isNaN(number) || number == null) {
    return 0;
  }
  
  
  number = (number / 100.0).toFixed(precision);
  // console.log('number', number);
  const parts = number.split('.');
  const dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
  const cents = parts[1] ? (decimal + parts[1]) : '';
  
  return '$' + dollars + cents;
}

async function inveterateInit() {
  // console.log('inveterateInit');

  changePrice();
  changePrices();
  
  let cart = await loadCart();
  let has_inveterate_product = false;
  for (let i = 0; i < cart.items.length; i++) {
    if (cart.items[i].properties && cart.items[i].properties._inveterate_subscription) {
      has_inveterate_product = true;
    }
  }
  
  // console.log('has_inveterate_product', has_inveterate_product);
  if (has_inveterate_product) {
    if (cart.items.length == 1) {
      await removeVip(window.location.pathname === '/cart');
    } else if (window.AW_INVETERATE.member === 'member') {
      refreshCart(); // trigger Shopify Line Items Script to remove VIP product
    }

    if (!window.AW_INVETERATE.site_wide) {
      let has_vip_products = false;
      for (let i = 0; i < cart.items.length; i++) {
        if (cart.items[i].properties && cart.items[i].properties.__vip_product) {
          has_vip_products = true;
          break;
        }
      }
      // console.log('vip_products', vip_products);
      if (!has_vip_products) {
        await removeVip(window.location.pathname === '/cart');
      }
    }
  }
  
  const vipButton = document.querySelector('.js-join-vip');
  if (vipButton) {
    vipButton.addEventListener('click', function () {
      addVip(true);
    });
  }
  
  const regularButton = document.querySelector('.js-join-normal');
  if (regularButton) {
    regularButton.addEventListener('click', async function () {
      await removeVip(true);
    });
  }

  document.querySelectorAll('.bm-variants').forEach((select) => {
    select.addEventListener('change', (event) => {
      changePrices();
    });
  });
  
  const cartInveterate = document.querySelector('.cart-inveterate');
  if (cartInveterate && regularButton && regularButton.classList.contains('active')) {
    addVip(false).then(async () => {
      let cart = await loadCart();
      
      if (cart && cart.total_price > 0) {
        document.querySelector('.js-cart-discount').innerHTML = formatWithDelimiters(cart.total_price);
        document.querySelector('.js-cart-discount').classList.remove('hidden');
        removeVip(false).then(() => {
          if (cartInveterate) {
            document.querySelector('.cart-inveterate').classList.add('ready');
          }
        });
      }
      //console.log(cart);
    });
  } else {
    if (cartInveterate) {
      document.querySelector('.cart-inveterate').classList.add('ready');
    }
  }
}

function showPrice() {
  const pricesElement = document.querySelectorAll('.product-price__price');
  pricesElement.forEach(function (priceElement) {
    priceElement.style.display = 'inline-block';
    if (priceElement.classList.contains('new-price')) {
      const parent = priceElement.parentElement;
      // console.log('parent', parent);
      const old_discount = parent.querySelector('s.product-price__price');
      if (old_discount) {
        old_discount.style.display = 'none';
      }
    }
  });
}

function changePrices() {
  if (typeof window.AW_INVETERATE === 'undefined' || typeof window.AW_INVETERATE.page === 'undefined') {
    showPrice();
    return;
  }

  if (!window.AW_INVETERATE.site_wide && (window.AW_INVETERATE.member === 'new' || window.AW_INVETERATE.member === 'false')) {
    showPrice(); // TODO: Need to comment when launch
    return;
  }
  
  let text = '';
  if (window.AW_INVETERATE.member === 'new' || window.AW_INVETERATE.member === 'false') {
    text = 'New vip offer';
  }
  if (window.AW_INVETERATE.member === 'member') {
    text = 'Vip offer';
  }
  
  const pricesElement = document.querySelectorAll('.product-price__price');
  pricesElement.forEach(function (priceElement) {
    let productType = priceElement.getAttribute('data-product-type');
    let productPrice = priceElement.getAttribute('data-product-price');
    
    if (productType && productPrice) {
      let discount = window.AW_INVETERATE.inveterate_pricelist.find(product_entry => product_entry.product_type === productType);
      if (typeof discount === 'undefined') {
        return;
      }

      let new_price = getNewPrice(discount);
      let bundleDetails = getBundleDetails(discount, productPrice);

      new_price = parseFloat(new_price[1]) / 100;
      if (new_price === 0) {
        return;
      }
      let changedPrice = productPrice - productPrice * new_price;
      new_price = formatCurrency(changedPrice / 100);
      priceElement.classList.add('new-price');
      let old_price = '';
      if (bundleDetails.bundle_text) {
        new_price += ' ' + bundleDetails.bundle_text;
      } else {
        old_price = `<span class="old_in_price">${formatCurrency(productPrice / 100)}</span>`
      }
      priceElement.innerHTML = `<span class="in_container"><span class="in_text">${text}</span> <span><span class="in_price">${new_price}</span> ${old_price}</span></span>`;
    }
  });
  showPrice();
}

function changePrice() {
  if (typeof window.AW_INVETERATE === 'undefined' || typeof window.AW_INVETERATE.page === 'undefined' || window.AW_INVETERATE.page !== 'product') {
    return;
  }

  if (!window.AW_INVETERATE.site_wide && (window.AW_INVETERATE.member === 'new' || window.AW_INVETERATE.member === 'false')) {
    return; // TODO: Need to comment when launch
  }
  
  const priceElement = document.querySelector('#ProductPrice-product-template');
  const comparePriceElement = document.querySelector('#ComparePrice-product-template');
  const variant_id = document.querySelector('select[name="id"]').selectedOptions[0].value;
  const selectedVariant = window.AW_INVETERATE.product.variants.find(variant => variant.id == variant_id);
  
  
  if (!priceElement || !comparePriceElement || !selectedVariant) {
    return;
  }
  
  const price = window.AW_INVETERATE.inveterate_pricelist.find(product_entry => product_entry.product_type === window.AW_INVETERATE.product.type);
  if (!price) {
    return;
  }
  
  
  let new_price = getNewPrice(price);
  let bundleDetails = getBundleDetails(price, selectedVariant.price);
  
  // console.log('selectedVariant3', selectedVariant.price);
  // console.log('new_price', new_price[1]);
  // if (selectedVariant.price < new_price[1] * 100) {
  //   return;
  // }
  updatePriceDisplay(priceElement, comparePriceElement, selectedVariant, new_price[1], bundleDetails);
}

function updatePriceDisplay(priceElement, comparePriceElement, selectedVariant, new_price, bundleDetails) {
  new_price = parseFloat(new_price) / 100;
  if (new_price === 0) {
    return;
  }
  // console.log('selectedVariant.price', selectedVariant.price);
  // console.log('new_price', new_price);
  let changedPrice = selectedVariant.price - selectedVariant.price * new_price;
  new_price = formatCurrency(changedPrice/100);
  
  comparePriceElement.style.display = 'none';
  priceElement.innerHTML = `NON-MEMBER: ${formatWithDelimiters(selectedVariant.price)}`;
  
  const existingVipPriceElement = document.querySelector('.vip-price');
  if (existingVipPriceElement) {
    existingVipPriceElement.remove();
  }
  
  let vipPriceHtml = `<span class="vip-price"><span class="inveterate-price-text">${window.AW_INVETERATE.member === 'member' ? 'Vip offer:' : 'New vip offer:'}</span>
                      <span class="inveterate-price__price">
                          ${new_price}`;
  if (bundleDetails && bundleDetails.bundle_text) {
    vipPriceHtml += ` ${bundleDetails.bundle_text}`;
  }
  vipPriceHtml += '</span></span>';
  
  priceElement.insertAdjacentHTML('beforebegin', vipPriceHtml);
  document.querySelector('body').classList.add('inv-ready');
  updateAdditionalPriceBlocks(new_price, bundleDetails, selectedVariant);
}

function updateAdditionalPriceBlocks(new_price, bundleDetails, selectedVariant) {
  const blockVipPrice = document.querySelector('.inveterate_buttons_wrapper .vip_button .new_vip_offer .inveterate-price__price');
  if (blockVipPrice) {
    blockVipPrice.innerHTML = new_price + (bundleDetails.bundle_text ? ' ' + bundleDetails.bundle_text : '');
  }
  
  const blockRegularPrice = document.querySelector('.inveterate_buttons_wrapper .regular_button .product-price__price span');
  if (blockRegularPrice) {
    blockRegularPrice.innerHTML = formatWithDelimiters(selectedVariant.price);
  }
  
  const VipPrice = document.querySelector('.inveterate_buttons_wrapper .vip_button .new_vip_offer');
  if (VipPrice) {
    VipPrice.style.display = 'block';
  }
}


function getNewPrice(price) {
  if (window.AW_INVETERATE.member === 'new' || window.AW_INVETERATE.member === 'false') {
    return [formatCurrency(price.new_member_price), price.new_member_price];
  }
  if (window.AW_INVETERATE.member === 'member') {
    return [formatCurrency(price.member_price), price.member_price];
  }
  return 0;
}

function getBundleDetails(price, original_price) {
  if (price.bundle && (window.AW_INVETERATE.member === 'new' || window.AW_INVETERATE.member === 'false')) {
    let [bundle_count, bundle_price] = price.bundle.split('*');
    bundle_price = bundle_price / 100;
    bundle_price = (original_price - original_price * bundle_price) / 100;
    return {
      bundle_text: `<span class='grey'>or</span> ${bundle_count} for ${formatCurrency(bundle_price * bundle_count)}`
    };
  }
  return {};
}



//Shogun template
function isPropertyAvailable(obj, path) {
  return path.reduce((acc, part) => acc && acc[part], obj) !== undefined;
}

if (window.SH_THEMPLATE === 'shogun') {
  let checkShg = setInterval(() => {
    const requiredProps = [['inveterate', 'properties', 'product'], ['__shgProductInits']];
    
    if (requiredProps.every(path => isPropertyAvailable(window, path)) &&
      window.__shgProductInits.length > 0 &&
      window.__shgProductInits[0].product !== undefined) {
      clearInterval(checkShg);
      run();
    }
  }, 50);
}

async function run() {
  /*let cart = await loadCart();
  
  for (let i = 0; i < cart.items.length; i++) {
    if (cart.items[i].properties._inveterate_subscription) {
      document.querySelector('.shg-category').classList.add('vip');
    }
  }*/
  
  for (let i = 0; i < window.__shgProductInits.length; i++) {
    const product = window.__shgProductInits[i];
    const id = product.uuid;
    const wrapper = document.getElementById(id);
    const price = window.AW_INVETERATE.inveterate_pricelist.find(product_entry => product_entry.product_type === product.product.type);
    
    //New price
    let text = '';
    let newPrice = 0;
    if (window.AW_INVETERATE.member === 'new' || window.AW_INVETERATE.member === 'false') {
      text = 'New vip offer:';
      newPrice = price.new_member_price;
    }
    if (window.AW_INVETERATE.member === 'member') {
      text = 'Vip offer:';
      newPrice = price.member_price;
    }
    newPrice = newPrice / 100;
    
    for (let j = 0; j < product.product.variants.length; j++) {
      product.product.variants[j].original_price = product.product.variants[j].price;
      product.product.variants[j].price = product.product.variants[j].price - product.product.variants[j].price * newPrice;
    }
    
    let variant_data = fn_get_variant_from_url(product);
    if (!variant_data) {
      variant_data = product.product.variants[0];
    }
    fn_change_shogun_price(variant_data, id, text, price);
    
    wrapper.addEventListener('change', function(event) {
      if (event.target && event.target.matches('.shg-product-variant-select')) {
        let variant_data = fn_get_variant_from_url(product);
        fn_change_shogun_price(variant_data, id, text, price);
      }
    });
  }
  
  
  /*const forms = document.querySelectorAll('.shg-product-atc-btn-wrapper');
  forms.forEach(form => {
    form.addEventListener("submit", function (event) {
      event.preventDefault();
      document.querySelector('.shg-category').classList.remove('ready');
      let idInput = this.closest('form').querySelector('[name="id"]');
      let idButton = this.closest('form').querySelector('.rca-add-to-cart-submit');
      let id = idInput ? idInput.value : null;
      
      if (window.AW_INVETERATE.member === 'member' || document.querySelector('.shg-category').classList.contains('vip')) {
        fn_add_shogun_product(id, idButton);
      } else {
        addVip()
          .then(() => {
            fn_add_shogun_product(id, idButton);
          })
          .catch((error) => {
            console.error('Error:', error);
          });
      }
    });
  });*/

  if (!window.AW_INVETERATE.site_wide && window.AW_INVETERATE.member !== 'member') {
    document.querySelectorAll('form.rca-add-to-cart-submit').forEach(element => {
      element.insertAdjacentHTML('afterbegin', '<input type="hidden" name="properties[__vip_product]" value="true" />');
    });
  }

  document.querySelectorAll('a.rca-add-to-cart-submit').forEach(element => {
    element.addEventListener('click', event => {
      if (event.target === element && window.AW_INVETERATE.member !== 'member') {
        setTimeout(addVip, 500);
      }
    });
  });  
  
  document.querySelector('.shg-category').classList.add('ready');
}

function fn_get_variant_from_url(product) {
  var currentUrl = window.location.search;
  var urlParams = new URLSearchParams(currentUrl);
  var variant = urlParams.get('variant');
  variant = parseInt(variant, 10);
  return product.product.variants.find(variant_entry => variant_entry.id === variant);
}
function fn_change_shogun_price(variant_data, id, text, price) {
  const wrapper = document.getElementById(id);
  let newPriceData = variant_data.price / 100;
  let newPriceHtml = formatCurrency(newPriceData);
  
  const existingVipPriceElement = wrapper.querySelector('.vip-price');
  if (existingVipPriceElement) {
    existingVipPriceElement.remove();
  }
  
  const existingVipPrice2Element = wrapper.querySelector('.vip-price2');
  if (existingVipPrice2Element) {
    existingVipPrice2Element.remove();
  }
  
  const newElementHtml2 = `<p class="vip-price2"><span class="inveterate-price-text">${text}</span></p> `;
  wrapper.querySelector('.shg-product-price').insertAdjacentHTML('beforebegin', newElementHtml2);
  
  //Add bundle price
  let bundle_price = 0;
  let bundle_amount = 0;
  let bundle_text = '';
  if (window.AW_INVETERATE.member === 'new' || window.AW_INVETERATE.member === 'false') {
    if (price.bundle) {
      bundle_price = price.bundle.split('*')[1]/100;
      bundle_amount = price.bundle.split('*')[0];
      
      bundle_price = (variant_data.original_price - variant_data.original_price * bundle_price) / 100;
    }
    if (bundle_price > 0) {
      bundle_price = formatCurrency(bundle_price * bundle_amount);
      bundle_text = `<span class='grey'>or</span> ${bundle_amount} for ${bundle_price}`;
    }
  }
  
  const newElementHtml = `<span class="vip-price"><span class="inveterate-price-text2">${newPriceHtml} ${bundle_text}</span></span> `;
  wrapper.querySelector('.shg-product-price').insertAdjacentHTML('beforebegin', newElementHtml);
  
  if (bundle_text !== '') {
    const cssStyle = `<style>#${id} .shg-product-price {display: none !important;}</style>`;
    wrapper.querySelector('.shg-product-price').insertAdjacentHTML('beforebegin', cssStyle);
  }
  
}

//Functions
/*async function fn_add_shogun_product(id, button) {
  try {
    const addToCartResponse = await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        quantity: 1,
        id: id,
        properties: {
          '__vip_product': true
        },
      })
    });
    
    if (!addToCartResponse.ok) {
      throw new Error(`HTTP error! Status: ${addToCartResponse.status}`);
    }
    
    const addToCartData = await addToCartResponse.json();
    //console.log('Success:', addToCartData);
    
    document.querySelector('.shg-category').classList.add('ready');
    let old_text = button.innerHTML;
    button.innerHTML = 'Added to your cart';
    button.classList.add('shg-product-atc-disabled', 'shg-product-atc-success');
    
    let cart = await loadCart();
    let cart_count = cart.item_count;
    //console.log('cart', cart);
    
    if (document.querySelector('.shg-category').classList.contains('vip')) {
      cart_count = cart_count - 1;
    }
    
    document.querySelector('#CartCount span:first-of-type').innerHTML = cart_count; // Updated to reflect actual cart count
    document.querySelector('#CartCount').style.display = 'block';
    
    setTimeout(function () {
      button.innerHTML = old_text;
      button.classList.remove('shg-product-atc-disabled', 'shg-product-atc-success');
    }, 3000);
    
  } catch (error) {
    console.error('Error:', error);
  }
}*/

function addVip(redirect = false) {
  return loadCart().then(cart => {
    const hasSubscription = cart.items.some(item => item.properties && item.properties._inveterate_subscription);
    
    if (hasSubscription) {
      return Promise.resolve(cart);
    }
    
    const inveterate_product = {
      'product_id': window.inveterate.properties.product.id,
      'variant_id': window.inveterate.properties.product.variants[0].id,
      'selling_plan_id': window.inveterate.properties.product.selling_plan_groups[0].selling_plans[0].id,
    };
    
    if (redirect) {
      document.querySelector('body').classList.add('is-loading');
    }
    
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        quantity: 1,
        id: inveterate_product.variant_id,
        selling_plan: inveterate_product.selling_plan_id,
        properties: {
          _inveterate_subscription: true
        },
      })
    })
      .then(response => {
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        return response.json();
      })
      .then(data => {
        //console.log('Success:', data);
        
        if (redirect) {
          window.location.href = '/cart';
        }
        
        return data;
      })
      .catch(error => {
        console.error('Error:', error);
        if (redirect) {
          window.location.href = '/cart';
        }
        throw error;
      });
  });
}

async function removeVip(redirect = false) {
  if (redirect) {
    document.querySelector('body').classList.add('is-loading');
  }
  
  try {
    const response = await fetch('/cart.js');
    const cart = await response.json();
    const variantIdToRemove = window.inveterate.properties.product.variants[0].id;
    const lineItemIndex = cart.items.findIndex(item => item.variant_id === variantIdToRemove);
    
    if (lineItemIndex !== -1) {
      const removeResponse = await fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          quantity: 0,
          line: lineItemIndex + 1
        })
      });
      
      if (!removeResponse.ok) {
        throw new Error(`HTTP error! Status: ${removeResponse.status}`);
      }
      
      await removeResponse.json();
    }
    
    if (redirect) {
      window.location.href = '/cart';
    }
  } catch (error) {
    console.error('Error:', error);
    if (redirect) {
      window.location.href = '/cart';
    }
  }
}

function refreshCart(redirect = false) {
  fetch('/cart.js')
    .then(response => {
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }
      return response.json();
    })
    .then(cart => {
      if (cart.items.length > 0) {
        return fetch('/cart/change.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            quantity: cart.items[0].quantity,
            line: 1 // Line item indices start at 1 in Shopify's cart/change.js endpoint
          })
        });
      } else {
        throw new Error("Cart is empty");
      }
    })
    .then(response => {
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }
      return response.json();
    })
    .then(data => {
      //console.log('Cart refreshed:', data);
      if (redirect) {
        window.location.href = '/cart';
      }
    })
    .catch(error => {
      console.error('Error:', error);
      if (redirect) {
        window.location.href = '/cart';
      }
    });
}

async function loadCart() {
  try {
    const response = await fetch('/cart.js');
    if (!response.ok) throw new Error('Network response was not ok');
    const cart = await response.json();
    return cart;
  } catch (error) {
    console.error('Error fetching cart:', error);
    return null; // Return null or any other appropriate value to signify failure
  }
}

function formatCurrency(value) {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 2
  }).format(value);
}

